import { useRouteError } from "react-router-dom";

export default function ErrorPage() {
    const error = useRouteError();
    console.error(error);

    return (
        <div id="error-page">
            <h1>خطا!</h1>
            <p>متاسفانه یک خطای غیرمنتظره رخ داد.</p>
            <p>
                با تهیه یک عکس لطفا با پشتیبانی به اشتراک بگذارید.
                <br />
                <i>{error.status} | {error.message}</i>
            </p>
        </div>
    );
}